// extracted by mini-css-extract-plugin
module.exports = {"root":"RangeThumb_root__1-vdM","affordance":"RangeThumb_affordance__3CL4Q"};